import { render } from "./DataProjectEdit.vue?vue&type=template&id=82d888a2&scoped=true"
import script from "./DataProjectEdit.vue?vue&type=script&lang=js"
export * from "./DataProjectEdit.vue?vue&type=script&lang=js"

import "./DataProjectEdit.vue?vue&type=style&index=0&id=82d888a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82d888a2"]])

export default __exports__